import React, { useState } from 'react';
import "./Tooltip.css"; 

interface TooltipProps {
  title: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  trigger?: 'mouseenter' | 'click' | 'focus';
  children: React.ReactNode;
  className?: string;
}

const Tooltip: React.FC<TooltipProps> = ({ title, position = 'top', trigger = 'mouseenter', children ,className = "",}) => {
    
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseEnter = () => {
    if (trigger === 'mouseenter') setIsVisible(true);
  };

  const handleMouseLeave = () => {
    if (trigger === 'mouseenter') setIsVisible(false);
  };

  const handleClick = () => {
    if (trigger === 'click') setIsVisible(!isVisible);
  };

  const handleFocus = () => {
    if (trigger === 'focus') setIsVisible(true);
  };

  const handleBlur = () => {
    if (trigger === 'focus') setIsVisible(false);
  };

  return (
    <div
      className="tooltip-container"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
      onFocus={handleFocus}
      onBlur={handleBlur}
    >
      <div
        className={`tooltip-content ${position} ${
          isVisible ? 'visible' : ''
        } ${className}`}
        role="tooltip"
        aria-hidden={!isVisible}
      >
        {title}
      </div>
      {children}
    </div>
  );
};

export default Tooltip;